import effectManager from '../effect';
import Param from '../../param';

const param = new Param();
const effect = new effectManager();

export default class globalNavi{
    constructor(){

        /* 必要なDOM */
        this.$container =  $("#l-header-screennavi__inner");
        this.$bg =  $("#l-header-screennavi__bg");
        this.$illust =  $("#l-header-screennavi__illust");
        this.$btn = $("#l-header-btn");
        this.$li =  $("#l-header-screennavi__content>ul>li");

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
            device : "pc",
            current : "",
        }


    }
    init() {

        let _this = this;

        _this.set(this.status.device);

        _this.$btn.on("click",function () {

            if(_this.status.now==="close"){
                _this.status.now = "open";
                _this.$btn.addClass("is-open");
                $("#l-header-screennavi").addClass("is-open");
                _this.motion("show");
            }else{
                _this.status.now = "close";
                _this.$btn.removeClass("is-open");
                $("#l-header-screennavi").removeClass("is-open");
                _this.motion("out");

            }

        });

        _this.$li.on("click",function () {
            setTimeout(function () {
                $("html,body").attr("style","")
            },2e2);
        });

        _this.$li.hover(function(){
            _this.status.current = $(this).data('link');
            $(this).addClass('is-current');
            $('#l-header-screennavi').addClass('is-'+_this.status.current);
            TweenMax.set(_this.$illust,{
                scale : 0.96,
                opacity : 0,
                display : 'none'
            });
            TweenMax.to(_this.$illust,0.38,{
                delay: 0.2,
                scale : 1,
                opacity : 1,
                display : 'block',
                ease: Back.easeOut.config(2)
            });
        },function(){
            $(this).removeClass('is-current');
            $('#l-header-screennavi').removeClass('is-'+_this.status.current);
            TweenMax.to(_this.$illust,0.2,{
                scale : 0.96,
                opacity : 0,
                display : 'none',
                ease: Back.easeIn.config(2)
            });
        });

    }

    motion(mode){

        let _this = this;

        if(mode === "show"){

            if (this.status.device === "pc") {
                let _comp = function () {
                    TweenMax.set(_this.$btn.find('.text-inner').eq(0), {display: 'none'});
                    TweenMax.set(_this.$btn.find('.text-inner').eq(1), {display: 'block'});
                    TweenMax.set(_this.$btn.find('.text-inner').eq(1).children(), {y: '8px', opacity: 0});
                    TweenMax.staggerTo(_this.$btn.find('.text-inner').eq(1).children(), 0.15, {
                        y: '0px',
                        opacity: 1,
                        ease: Back.easeIn.config(2),
                    }, 0.02);
                }
                TweenMax.staggerTo(this.$btn.find('.text-inner').eq(0).children(), 0.15, {
                    y: '-8px',
                    opacity: 0,
                    ease: Back.easeIn.config(2),
                }, 0.02, _comp);
            }

            TweenMax.to(this.$container,0.6,{
                scale : 1,
                opacity : 1,
                display : 'block',
                ease: Back.easeOut.config(2)
            });
            TweenMax.to(this.$bg,0.6,{
                delay : 0.04,
                x : 0 +"%",
                opacity : 1,
                display : 'block',
                ease: Back.easeOut.config(2)
            });

            $('body,html').css({"overflow":"hidden","height":"100%"});
            TweenMax.to($("#l-pagetop"),0.48,{
                x:100
            });

        }else{

            if (this.status.device === "pc") {
                let _comp = function () {
                    TweenMax.set(_this.$btn.find('.text-inner').eq(0), {display: 'block'});
                    TweenMax.set(_this.$btn.find('.text-inner').eq(0).children(), {y: '-8px', opacity: 0});
                    TweenMax.set(_this.$btn.find('.text-inner').eq(1), {display: 'none'});
                    TweenMax.staggerTo(_this.$btn.find('.text-inner').eq(0).children(), 0.15, {
                        y: '0px',
                        opacity: 1,
                        ease: Back.easeIn.config(2),
                    }, 0.02);
                }
                TweenMax.staggerTo(this.$btn.find('.text-inner').eq(1).children(), 0.15, {
                    y: '8px',
                    opacity: 0,
                    ease: Back.easeIn.config(2),
                }, 0.02, _comp);
            }

            TweenMax.to(this.$container,0.6,{
                scale : 0.9,
                opacity : 0,
                display : 'none',
                ease: Back.easeIn.config(2)
            });
            TweenMax.to(this.$bg,0.6,{
                x : -50 +"%",
                opacity : 0,
                display : 'none',
                ease: Back.easeIn.config(2)
            });

            $('body,html').css({"overflow":"","height":""});
            TweenMax.to($("#l-pagetop"),0.48,{
                x:0
            });


        }

    }

    /* 初期化するやつ */
    set(device) {
        if (this.status.device === "pc"){
            TweenMax.to(this.$btn,0.48,{
                y:0
            });
        }
        TweenMax.set(this.$btn.find('.text-inner').eq(0), {display: 'block'});
        TweenMax.set(this.$btn.find('.text-inner').eq(1), {display: 'none'});
        TweenMax.set(this.$container,{ scale : 0.9, opacity:0,display:'none' });
        TweenMax.set(this.$bg,{ x:-50+"%",opacity:0,display:'none' });
        this.status.now = "close";
        this.$btn.removeClass("is-close");
    }

    resize(){
        let _w = window.innerWidth;
        if(_w>param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }
}